export * from './dtos/proto-language.dto';
